export default "__VITE_ASSET__HqZs$nMz__"